import i18n from 'modules/core/lib/i18n'

export type TrainingRequestStatus = 'approved' | 'draft' | 'rejected' | 'review' | undefined


export const getStatusColor = (status: TrainingRequestStatus) => {
  switch (status) {
    case 'approved':
      return 'positive'
    case 'draft':
      return 'neutral'
    case 'rejected':
      return 'warning'
    case 'review':
      return 'info'
    default:
      return 'neutral'
  }
}

export const getStatusLabel = (status: TrainingRequestStatus): string => {
  switch (status) {
    case 'approved':
      return i18n.t('trainings.training_requests.requests.datatable.approved')
    case 'draft':
      return i18n.t('trainings.training_requests.my_requests.datatable.status_tag.draft')
    case 'rejected':
      return i18n.t('trainings.training_requests.requests.datatable.rejected')
    case 'review':
      return i18n.t('trainings.training_requests.requests.datatable.pending')
    default:
      return '-'
  }
}
